import Contact from "../HomePage/ContactSection";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import SEO from "../SEO/SEO"

const ContactPage = () => {
  return (
    <>
      <Header />
      <SEO
        title="Contact | Nexora Machinery"
        description="Learn about Nexora Machinery, a trusted supplier of CNC Turning Centers, VMC Machines, Milling Machines, Tapping Machines and industrial machinery."
        keywords="About Nexora Machinery, CNC Machine Supplier"
        path="/contact"
      />
      <section className="relative bg-gradient-to-br from-[#002946] via-[#004e7c] to-[#0066a5] text-white py-20 lg:py-28 mt-20">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
              Contact <span className="text-[#00d9ff]">Us</span>
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 font-light mb-8">
              Get in Touch for Industrial Solutions
            </p>
            <div className="w-24 h-1 bg-[#00d9ff] mx-auto mb-8"></div>
          </div>
        </div>
      </section>
      <main className="mt-20">
        <Contact />
      </main>
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="text-[#00d9ff] font-semibold text-lg">FAQ</span>
            <h2 className="text-3xl lg:text-4xl font-bold text-[#002946] mt-2 mb-6">
              Frequently Asked Questions
            </h2>
          </div>
          <div className="space-y-6">
            {[
              {
                question: "What types of machinery do you supply?",
                answer:
                  "We supply various industrial machinery including CNC machines, lathe machines, milling machines, drilling machines, and other manufacturing equipment.",
              },
              {
                question: "Do you provide technical support?",
                answer:
                  "Yes, we provide technical consultation and guidance for selecting the right machinery and basic installation support.",
              },
              {
                question: "What is your delivery timeline?",
                answer:
                  "Delivery timelines vary based on product availability and location. Typically, we deliver within 7-15 days across India.",
              },
              {
                question: "Do you offer after-sales service?",
                answer:
                  "We provide after-sales support including installation guidance, maintenance recommendations, and spare part identification.",
              },
            ].map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200"
              >
                <h3 className="text-lg font-bold text-[#002946] mb-3">
                  {faq.question}
                </h3>
                <p className="text-gray-600">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default ContactPage;
